<mat-toolbar class="sidenav-header">
	<div class="menu-container">
		<button
			mat-icon-button
			class="pg-header-btn"
			mat-dialog-close
			(click)="close($event)"
		>
			<mat-icon>close</mat-icon>
		</button>
		<div class="pg-title">{{ "auth.changePass" | translate }}</div>
		<span fxFlex></span>
	</div>
</mat-toolbar>
<mat-divider></mat-divider>
<form [formGroup]="passwordGroup" (ngSubmit)="submit()">
	<div class="form-field">
		<mat-form-field appearance="outline" class="reset-input">
			<mat-label>{{ "auth.currentPass" | translate }}</mat-label>
			<input
				formControlName="currentPassword"
				matInput
				[type]="hide ? 'password' : 'text'"
			/>
			<button
				type="button"
				mat-icon-button
				matSuffix
				(click)="hide = !hide"
				[attr.aria-label]="'Hide password'"
				[attr.aria-pressed]="hide"
			>
				<mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
			</button>
			<mat-error>{{ "error.currentPassRequired" | translate }}</mat-error>
		</mat-form-field>

		<mat-form-field appearance="outline" class="reset-input pt-sm">
			<mat-label>{{ "auth.newPass" | translate }}</mat-label>
			<input
				matInput
				formControlName="newPassword"
				[type]="hide ? 'password' : 'text'"
				placeholder="New Password"
			/>
			<button
				type="button"
				mat-icon-button
				matSuffix
				(click)="hide = !hide"
				[attr.aria-label]="'Hide password'"
				[attr.aria-pressed]="hide"
			>
				<mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
			</button>
			<mat-error>{{ passwordErrorMessage }}</mat-error>
		</mat-form-field>
		<!-- Confirm Password -->
		<mat-form-field appearance="outline" class="reset-input pt-sm">
			<mat-label>{{ "auth.repeatNewPass" | translate }}</mat-label>
			<input
				matInput
				formControlName="repeatNewPassword"
				[type]="hide ? 'password' : 'text'"
				placeholder="Confirm Password"
			/>
			<button
				type="button"
				mat-icon-button
				matSuffix
				(click)="hide = !hide"
				[attr.aria-label]="'Hide password'"
				[attr.aria-pressed]="hide"
			>
				<mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
			</button>
			<mat-error
				*ngIf="
					passwordGroup.get('repeatNewPassword').touched &&
					passwordGroup.hasError('required')
				"
				>Confirm Password is required</mat-error
			>
			<mat-error
				*ngIf="
					passwordGroup.get('repeatNewPassword').touched &&
					passwordGroup.hasError('mismatch')
				"
				>{{ "error.passNoMatch" | translate }}</mat-error
			>
		</mat-form-field>
		<div class="validation-text">
			<span
				[ngStyle]="{
					color:
						!passwordGroup.get('newPassword').value ||
						passwordGroup.get('newPassword').hasError('minlength')
							? '#99abb4'
							: 'green'
				}"
				>{{ "error.atLeastLength" | translate }}</span
			>
			<span
				[ngStyle]="{
					color:
						!passwordGroup.get('newPassword').value ||
						passwordGroup.get('newPassword').hasError('pattern')
							? '#99abb4'
							: 'green'
				}"
				>{{ "error.oneSpecialChar" | translate }}</span
			>
		</div>
		<button
			mat-raised-button
			color="primary"
			class="full-width mt-md"
			[disabled]="passwordGroup.invalid"
		>
			{{ "auth.updatePassword" | translate }}
		</button>
	</div>
</form>
